import {Button, Col, Form, Input, Row, TimePicker, Upload} from "antd";
import React from "react";
import { updateGeneral } from "../../Store/Actions/shop";
const timeFormat = 'HH:mm';
const { RangePicker } = TimePicker;
const rules = [{ required: true }];


class General extends React.Component {

    state = {
        logoUrl: this.props.shop.logo,
        backgroundUrl: this.props.shop.background,
        logoList: [],
        backgroundList: [],
        uploading: false,
        current: 0,
    };


    readFile(file) {
        if(file) {
            return new Promise(resolve => {
                const reader = new FileReader()
                reader.addEventListener('load', () => resolve(reader.result), false)
                reader.readAsDataURL(file)
            })
        } else {
            return "https://i0.wp.com/www.charitycomms.org.uk/wp-content/uploads/2019/02/placeholder-image.jpg?ssl=1"
        }
    }

    firstFinish = values => {
        this.setState({
            uploading: true
        })
        let files = {};
        if(this.state.backgroundList.length > 0){
            files.background = this.state.backgroundList[0];
        }
        if(this.state.logoList.length > 0){
            files.logo = this.state.logoList[0];
        }
        const { shop } = this.props;
        updateGeneral(shop.id, values, files, res => {
            this.setState({
                uploading: false
            })
        })
    };


    render() {
        const { uploading, logoList, backgroundList, backgroundUrl, logoUrl, current } = this.state;
        const { shop } = this.props;
        const logoProps = {
            onRemove: file => {
                this.setState(state => {
                    return {
                        logoList: [],
                    };
                });
            },
            beforeUpload: async (file) => {
                let self = this;
                let image = new Image();
                image.src = await this.readFile(file);
                image.onload = function(imageUrl){
                    self.setState({
                        logoUrl: imageUrl.target.src,
                        logoList: [file]
                    });
                };
                return false;
            },
            fileList: logoList,
            showUploadList:false,
            listType: "picture-card"
        };
        const backgroundProps = {
            onRemove: file => {
                this.setState(state => {
                    return {
                        backgroundList: [],
                    };
                });
            },
            beforeUpload: async (file) => {
                let self = this;
                let image = new Image();
                image.src = await this.readFile(file);
                image.onload = function(imageUrl){
                    self.setState({
                        backgroundUrl: imageUrl.target.src,
                        backgroundList: [file]
                    });
                };
                return false;
            },
            fileList: backgroundList,
            showUploadList:false,
            listType: "picture-card"
        };


        return (
            <Row gutter={8}>
                <Col span={12}>
                    <div>
                        <h3 className="uk-h2 uk-text-bold">
                            Update your shop
                        </h3>

                        <div>
                            <Form initialValues={shop} onFinish={this.firstFinish} layout="vertical" hideRequiredMark>
                                <Form.Item
                                    name="title"
                                    label={
                                        <h3 className="uk-h4 uk-margin-remove">
                                            Shop name
                                        </h3>
                                    }
                                    rules={[{ required: true, message: 'Please enter shop name' }]}
                                >
                                    <Input size="large" placeholder="Please enter shop name" />
                                </Form.Item>

                                <Row gutter={16}>
                                    <Col>
                                        <Form.Item rules={rules} className="uk-margin-remove">
                                            <div>
                                                <Upload {...logoProps}>
                                                    { logoUrl ? <img src={logoUrl} alt="avatar" style={{ width: '100%' }} /> :
                                                        <span>
                                                                                <i uk-icon="camera" /><br/>
                                                                                Upload logo
                                                                            </span>
                                                    }
                                                </Upload>
                                            </div>
                                        </Form.Item>
                                    </Col>
                                    <Col>
                                        <Form.Item rules={rules} className="uk-margin-remove">
                                            <div>
                                                <Upload {...backgroundProps} className="background">
                                                    { backgroundUrl ? <img src={backgroundUrl} alt="avatar" style={{ width: '100%' }} /> :
                                                        <span>
                                                                                <i uk-icon="camera" /><br/>
                                                                                Upload background
                                                                            </span>
                                                    }
                                                </Upload>
                                            </div>
                                        </Form.Item>
                                    </Col>
                                </Row>

                                <Form.Item
                                    name="about"
                                    label={
                                        <h3 className="uk-h4 uk-margin-remove">
                                            About the shop
                                        </h3>
                                    }
                                    rules={[
                                        {
                                            required: true,
                                            message: 'Please write about the shop',
                                        },
                                    ]}
                                >
                                    <Input.TextArea size="large" rows={4} placeholder="About the shop" />
                                </Form.Item>

                                <Form.Item>
                                    <Button disabled={uploading} loading={uploading} size="large" type="primary" htmlType="submit">
                                        Update general info
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                    </div>
                </Col>
                <Col span={12}>
                    <div className="uk-padding">
                        <img className="uk-width-1-1" src={require("../Media/images/undraw_business_shop_qw5t.svg")} />
                    </div>
                </Col>
            </Row>
        );
    }

}


export default General;



// WEBPACK FOOTER //
// ./src/Components/Shop/General.js